import axios from 'axios';

export default async function getAllLocationGuests({
  accessToken,
  locationId,
  page = 0,
  pageSize = 100,
  query = '',
  isLoading,
}) {
  try {
    if (isLoading) isLoading(true);

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_GUESTS_API_URL}/location/${locationId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
}
